/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { BLUE_PRINCIPAL, DARK, GREEN, GREY_DARK, GREY_LIGHTS, RED, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export type ContainerOutsideProps = {
  type?: 'button' | 'link' | 'submit';
  href?: string;
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'white' | 'link' | 'muted' | 'danger';
  block?: boolean;
  className?: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
}

const ContainerOutside: FC<ContainerOutsideProps> = ({
  disabled,
  type,
  to,
  href,
  onClick,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block,
  ...props
}): ReactElement => {
  if (to) return <Link to={to} {...props} />

  if (type === 'button' || type === 'submit') {
    return <button onClick={onClick} disabled={disabled} type={type} {...props} />
  }

  return <a href={href} {...props} />
}

ContainerOutside.defaultProps = {
  type: 'button'
}

export const Container = styled(ContainerOutside)`
  cursor: pointer;
  font-family: 'Mont', sans-serif;
  padding: 22px 22px;
  border-radius: 100px;
  border: none;
  background: ${GREEN};
  color: ${WHITE} !important;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  display: inline-block;

  ${props => props.disabled && css`
    opacity: 0.5;
    cursor: not-allowed;
  `}

  .spinner {
    margin: 0 auto;
    svg {
      fill: ${WHITE};
    }
  }

  ${props => props.block && css`
    display: block;
    width: 100%;
  `}

  ${props => props.size === 'sm' && css`
    padding: 18px 12px;
    font-size: 12px;
  `}

  ${props => props.size === 'lg' && css`
    padding: 19px 61px;
    font-size: 20px;

    @media (max-width: ${MD}) {
      padding: 19px 35px;
    }
  `}

  ${props => props.variant === 'white' && css`
    color: ${GREEN} !important;
    background: ${WHITE};

    &:hover {
      background-color: ${BLUE_PRINCIPAL} !important;
      color: ${WHITE} !important;
    }

    .spinner {
      svg {
        fill: ${GREEN};
      }
    }
  `}

  ${props => (props.variant === 'muted' || props.disabled) && css`
    background: ${GREY_LIGHTS};
  `}

  ${props => (props.variant === 'danger') && css`
    background: ${RED};
  `}

  ${props => props.variant === 'link' && css`
    text-decoration-line: underline;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    font-size: 12px;
    background: transparent;
    color: ${GREY_DARK} !important;

    .spinner {
      margin: 0 auto;
      svg {
        fill: ${DARK};
      }
    }
  `}
`
